import type { ProductByIdPdp } from "@/Models/MPDP/ProductByIdPDP";
import type { products } from "@/Models/MProduct/Products";
import { formatMX } from "@/Utils/Fomat.price";

const normalizeToArray = (data: products | products[]): products[] => {
  return Array.isArray(data) ? data : [data];
};

export const mappersPDP = (
  data: products | products[],
  category: string,
  subCategory: string,
  ipClient: string
) => {
  if (normalizeToArray(data).length === 0) return [];

  if (data && category != "" && subCategory != "" && ipClient != "") {
    const dataPDP = (x: products): ProductByIdPdp => {
      return {
        id: x.Id,
        nameArticle: x.Name,
        brand: x.Brand,
        pricePerUnit: x.PricePerUnit,
        price: x.Price,
        imageGroups: x.ImageGroups,
        imageZoomGroups: x.ImageZoomGroups,
        longDescription: x.LongDescription,
        cCategory: x.CCategory, //cCategory,
        //cTab2Content: x.c_tab2Content,
        cTab2Content: x.CTab2Content,
        caracteristicas: x.Caracteristicas,
        listPriceBasket: x.ListPrice,
        salesPriceBasket: x.SalesPrice,
        listPrice: formatMX(x.ListPrice),
        salesPrice: formatMX(x.SalesPrice),
        cbvAverageRating: x.CBvAverageRating,
        cratesAndReviews: x.CRatesAndReviews,
        cbvRatingRange: x.CBvRatingRange,
        cconversionFactor: x.CConversionFactor,
        unit: x.Unit,
        cSalesUnit: x.CSalesUnit,
        listPrice_v2: x.ListPrice,
        ean: x.Ean,
        isDigital: x.IsDigital,
        cSaleLimit: x.CSaleLimit,
        cBadges: x.CBadges,
        minOrderQuantity: x.MinOrderQuantity,
        stepQuantity: x.StepQuantity,
        sellLimit: x.CSaleLimit,
        category: x.PrimaryCategoryId,
        subCategory: x.CCategory,
        Default: x.Default,
        ipClient: ipClient,
        xDefect: "Electrónica",
        promotions: x.Promotions,
      };
    };

    const resultData = normalizeToArray(data).map(dataPDP);

    return resultData;
  }
  return [];
};
